import { flattenFilterConfig } from "./flattenFilterConfig";

/**
 * Removes activeFilters whose filterId no longer exists in the current filterConfig.
 * Used to clean up stale filters when selected templates change.
 */
export const cleanStaleActiveFilters = ({ activeFilters, filterConfig }) => {
  const flat = flattenFilterConfig(filterConfig);
  const validIds = new Set(flat.map((f) => f.filterId));
  return activeFilters.filter((f) => validIds.has(f.filterId));
};
